import React, { useEffect, useRef, useState } from "react";
import { Link, useHref, useLocation } from "react-router-dom";
import Assets from "../../Layouts/Assets";
import Icon from "../../Layouts/Icons";
import Style from "./ProjectCard.module.scss";
import FolderMenu from "./Dropdown/FolderMenu";
import ProjectMenu from "./Dropdown/ProjectMenu";
import CardSelection from "./CardSelection";
import { useProjectSingle } from "../../../Logic/useProjectSingle";
import useProjects from "../../../Logic/useProjects";
import { useProjectCard } from "../../../Logic/useProjectCard";
import { useParams } from "react-router-dom";
import useGallery from "../../../Logic/useGallery";
import CommonModal from "../../Modals/CommonModal";
import { useDispatch } from "react-redux";
import { useGalleryTab } from "../../../Logic/useGalleryTab";
import { updateUploadMode } from "../../../store/slices/Gallery/fileUploadSlice";
import {
  allFolderData,
  getFolderDetailsByID,
} from "../../../store/slices/Project/ProjectSingle";
import { Dropdown } from "react-bootstrap";
import LockeModal from "../../Modals/LockerModal";
import { getFolderDetails } from "../../../store/slices/Gallery/gallerySlice";

const ProjectCard = ({
  data,
  preSelect,
  handleSingleSelection,
  isSelectionActive,
  setOpenEventInfoModal,
  setOpenEditProjectModal,
  setOpenDeleteModal,
  handleEditProject,
  handleViewProjectDetails,
  handleDeleteProjectID,
  handleProjectStatusID,
  setChangeProjectStatusModal,
  openCard,
  handleToggleEditFolder,
  deleteCard,
  handleEventPopup,
  handleGetEventPopupData,
  handlepaymentAlert,
  handlePaymentPage,
  getThumbnails,
  itemKey,
  isDropdownOpened,
  setIsDropdownOpened,
  onClick,
  outlineCard,
  hideMenu,
  isPaymentSuccess,
}) => {
  const {
    nameRef,
    charLength,
    currentTab,
    isImageLoad,
    setIsImageLoad,
    capitalizeFirstLetter,
    stopPropagationProcess,
  } = useProjectCard();

  const dispatch = useDispatch();
  const { isProjectSingle } = useProjectSingle();
  const {
    isProjectListing,
    handleShowAddProject,
    addProjectStepTwo,
    handleSetAddProjectStepOne,
    handleSetAddProjectStepTwo,
    handleSetStepOneFormData,
  } = useProjects();
  const location = useLocation();

  const {
    setIsShowNotifyModal,
    handleLockModal,
    isShowNotifyModal,
    shareNotificationSchema,
    handleLockAlbum,
    currentFolderDetails,
  } = useGallery();
  const [isDropdownHoverActive, setIsDropdownHoverActive] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(false);
  const handleShowModal = () => {
    setShowModal(!showModal);
    setModalData(false);
  };
  const handleDropdownMouseOver = function (event) {
    // setIsDropdownHoverActive(true);
  };
  const handleDropdownMouseLeave = function (event) {
    // setTimeout(function () {
    //   setIsDropdownHoverActive(false);
    // }, 500);
  };
  const handleDropdown = () => {
    let obj = {
      id: data?.id,
      url: "/album/get-album",
    };

    dispatch(getFolderDetails(obj));
  };
  let { projectID } = useParams();

  let arrayCheck = (data) => {
    let newArray = Array(0);

    if (data?.length == 4) {
      newArray = [...data];
    } else if (data?.length == 3) {
      newArray = [...data, ...Array(1)];
    } else if (data?.length == 2) {
      newArray = [...data, ...Array(2)];
    } else if (data?.length == 1) {
      newArray = [...data, ...Array(0)];
    } else {
      newArray = [...Array(1)];
    }

    return newArray;
  };
  return (
    <div
      key={itemKey}
      className={`${Style.ProjectCard} ${
        preSelect ? Style.preselectOpen : ""
      } ${outlineCard ? Style.outlined : ""}`}
    >
      <Link to={preSelect ? "" : data?.link ? data?.link : ""} />
      <div className={`${Style.ProjectCard_image_thumb_wrap}`}>
        <div className={Style.ProjectCard_image_thumb}>
          {location.pathname == "/dashboard/project" ||
          location.pathname == "/dashboard"
            ? arrayCheck(data?.latest_album?.latest_image)?.map(
                (items, index) => {
                  return (
                    <figure
                      key={index}
                      className={`${Style.ProjectCard__image} ${
                        items?.src?.thumbnail_small ? "" : Style.placeholder
                      } ${
                        !isImageLoad ? "img-loading-2" : "img-loading-2-loaded"
                      }`}
                    >
                      <img
                        src={
                          items?.src?.thumbnail_small
                            ? items?.src?.thumbnail_small
                            : Assets.placeholder_image_stack
                        }
                        className={
                          items?.src?.thumbnail_small
                            ? ""
                            : Style.image_placeholder
                        }
                        alt=""
                        onLoad={() => setIsImageLoad(true)}
                      />
                    </figure>
                  );
                }
              )
            : location.pathname == `/dashboard/project/${projectID}`
            ? arrayCheck(data?.latest_image)?.map((items, i) => {
                return (
                  <figure
                    key={i}
                    className={`${Style.ProjectCard__image} ${
                      data?.image ? "" : Style.placeholder
                    } ${
                      !isImageLoad ? "img-loading-2" : "img-loading-2-loaded"
                    }`}
                  >
                    <img
                      src={
                        items?.src?.thumbnail_small
                          ? items?.src?.thumbnail_small
                          : Assets.placeholder_image_stack
                      }
                      alt=""
                      onLoad={() => setIsImageLoad(true)}
                      className={
                        items?.src?.thumbnail_small
                          ? ""
                          : Style.image_placeholder
                      }
                    />
                  </figure>
                );
              })
            : ""}
        </div>
      </div>

      <div className={Style.ProjectCard__tray}>
        <div className={Style.ProjectCard__project}>
          <div className={Style.ProjectCard__projectName} ref={nameRef}>
            {data?.name}
          </div>
          <div className={Style.ProjectCard__projectDate}>{data?.date}</div>
        </div>
        <div
          onClick={
            onClick
              ? onClick
              : () => {
                  setModalData(true);
                  if (preSelect) {
                    handleSingleSelection(data.id);
                  } else {
                    openCard(data);
                  }
                }
          }
          className={Style.ProjectCard_link}
        ></div>
        {!preSelect && !hideMenu && (
          <div className={Style.ProjectCard__options}>
            <Dropdown
              onClick={(event) => {
                event.stopPropagation();
                handleDropdown();
              }}
              onMouseEnter={handleDropdownMouseOver}
              onMouseLeave={handleDropdownMouseLeave}
              className="options-dropdown"
              onTouchStart={handleDropdownMouseOver}
              onTouchEnd={handleDropdownMouseLeave}
            >
              <Dropdown.Toggle
                className={Style.option_dropdown}
                variant="custom"
              >
                {<Icon size={16} icon={"icon-three-dots"} />}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {isProjectListing() ? (
                  <ProjectMenu
                    data={data}
                    currentTab={currentTab}
                    handleEditProject={handleEditProject}
                    setOpenDeleteModal={setOpenDeleteModal}
                    setOpenEditProjectModal={setOpenEditProjectModal}
                    handleViewProjectDetails={handleViewProjectDetails}
                    setChangeProjectStatusModal={setChangeProjectStatusModal}
                    handleDeleteProjectID={handleDeleteProjectID}
                    handleProjectStatusID={handleProjectStatusID}
                    handleShowAddProject={handleShowAddProject}
                    addProjectStepTwo={addProjectStepTwo}
                    handleSetAddProjectStepOne={handleSetAddProjectStepOne}
                    handleSetAddProjectStepTwo={handleSetAddProjectStepTwo}
                    handleSetStepOneFormData={handleSetStepOneFormData}
                  />
                ) : isProjectSingle() ? (
                  <FolderMenu
                    data={data}
                    isPaymentSuccess={isPaymentSuccess}
                    deleteCard={deleteCard}
                    currentTab={currentTab}
                    setOpenEventInfoModal={setOpenEventInfoModal}
                    setOpenDeleteModal={setOpenDeleteModal}
                    handleToggleEditFolder={handleToggleEditFolder}
                    handleEventPopup={handleEventPopup}
                    handleGetEventPopupData={handleGetEventPopupData}
                    handlepaymentAlert={handlepaymentAlert}
                    handleLockModal={handleLockModal}
                    setIsLockModal={setIsShowNotifyModal}
                    currentFolderDetails={currentFolderDetails}
                  />
                ) : (
                  ""
                )}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        )}
      </div>
      <LockeModal
        isShowNotifyModal={isShowNotifyModal}
        setIsShowNotifyModal={setIsShowNotifyModal}
        validationSchema={shareNotificationSchema}
        handleLockAlbum={handleLockAlbum}
        isLocked={currentFolderDetails?.lock_status === "1"}
        data={data}
      />
      <CardSelection
        data={data}
        preSelect={preSelect}
        isSelectionActive={isSelectionActive}
        handleSingleSelection={handleSingleSelection}
      />
      {location.pathname == "/dashboard" &&
        data.client_id == null &&
        currentTab != "completedTab" && (
          <>
            <div className={Style.ProjectCard_noClient}>
              Please update client details!
            </div>
          </>
        )}
    </div>
  );
};

export default ProjectCard;
